import type {
  StoreIntegrationSettingsRequest,
  StoreIntegrationSettingsResponse,
  StoreIntegrationSettingsUsecase,
} from '@usecases/store-integration-settings.usecase';
import type { BaseController } from '@infra/controllers/base.controller';

export type StoreIntegrationSettingsInput = StoreIntegrationSettingsRequest;

export type StoreIntegrationSettingsOutput = StoreIntegrationSettingsResponse;

export class StoreIntegrationSettingsController
  implements
    BaseController<
      StoreIntegrationSettingsInput,
      StoreIntegrationSettingsOutput
    >
{
  constructor(private usecase: StoreIntegrationSettingsUsecase) {}
  async handle(
    req: StoreIntegrationSettingsInput,
  ): Promise<StoreIntegrationSettingsOutput> {
    return await this.usecase.run(req);
  }
}
